import {useRoutes} from "react-router-dom";

import {useAuth} from "./context/AuthContext";

import {LoadingSpinner} from "./components/LoadingSpinner";

import {LoginPage} from "./pages/LoginPage";

import {appRoutes} from "./routes/app-routes";



function App() {

	const {isAuthenticated, isLoading} = useAuth();

	const routes = useRoutes(appRoutes);



	if (isLoading) {

		return <LoadingSpinner/>;

	}



	if (!isAuthenticated) {

		return <LoginPage/>;

	}



	return routes;

}



export default App;

